import { createAction } from 'Lib/reduxUtils';

import {
  FETCH_CONSENTS,
  FETCH_CONSENTS_ERROR,
  FETCH_CONSENTS_REQUEST,
  FETCH_CONSENTS_SUCCESS,
  PRIVACY_SETTINGS_MANAGE,
  PRIVACY_SETTINGS_PROMPT,
  UPDATE_BIOMETRIC_CONSENTS,
  UPDATE_BIOMETRIC_CONSENTS_ERROR,
  UPDATE_BIOMETRIC_CONSENTS_SUCCESS,
  UPDATE_CONSENTS,
  UPDATE_CONSENTS_ERROR,
  UPDATE_CONSENTS_REQUEST,
  UPDATE_CONSENTS_SUCCESS,
  UPDATE_MESSAGING_CONSENTS,
  UPDATE_MESSAGING_CONSENTS_SUCCESS,
} from './constants';

export const fetchConsents = createAction(FETCH_CONSENTS);
export const fetchConsentsRequest = createAction(FETCH_CONSENTS_REQUEST);
export const fetchConsentsSuccess = createAction(FETCH_CONSENTS_SUCCESS, ({ result }: any) => ({
  result,
}));
export const fetchConsentsError = createAction(FETCH_CONSENTS_ERROR, (error: any) => error);

export const updateConsents = createAction(
  UPDATE_CONSENTS,
  (consents?: boolean | Record<string, boolean>) => ({ consents })
);
export const updateConsentsRequest = createAction(UPDATE_CONSENTS_REQUEST);
export const updateConsentsSuccess = createAction(
  UPDATE_CONSENTS_SUCCESS,
  ({ result }: any, deferredUpdate: boolean = false) => ({ result, deferredUpdate })
);
export const updateConsentsError = createAction(UPDATE_CONSENTS_ERROR, (error: any) => error);

export const updateMessagingConsents = createAction(
  UPDATE_MESSAGING_CONSENTS,
  (consentCode: string) => ({
    consentCode,
  })
);
export const updateMessagingConsentsSuccess = createAction(
  UPDATE_MESSAGING_CONSENTS_SUCCESS,
  ({ result }: any) => ({ result })
);

export const updateBiometricConsents = createAction(
  UPDATE_BIOMETRIC_CONSENTS,
  (consentCode: string) => ({
    consentCode,
  })
);
export const updateBiometricConsentsSuccess = createAction(
  UPDATE_BIOMETRIC_CONSENTS_SUCCESS,
  ({ result }: any) => ({ result })
);

export const updateBiometricConsentsError = createAction(
  UPDATE_BIOMETRIC_CONSENTS_ERROR,
  (error?: any) => error
);

export const privacySettingsPrompt = createAction(PRIVACY_SETTINGS_PROMPT);
export const privacySettingsManage = createAction(
  PRIVACY_SETTINGS_MANAGE,
  (open: boolean = true) => ({
    open,
  })
);
